<template>
  <div class="app flex-row align-items-center"  style="background-image: url('/img/login_background_Cool-connect-2.svg')  ;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left bottom;">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group class="shadow-lg mb-5 bg-white rounded">
            <b-card no-body class="p-4">
              <b-card-body>  
                <b-form novalidate @submit.prevent="onLogin" @input="onUpdate">
                  <h1>Login</h1>
                  <!-- <p class="text-muted">Inloggen op Meds 2 go Dashboard</p> -->
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input ref="username" type="text" autofocus class="form-control" v-model="form.username" placeholder="Username" autocomplete="username email" />
                    <b-form-invalid-feedback :state="form.errors.has('username')">
                      Username blank or incorrect
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" v-model="form.password" placeholder="Password" autocomplete="current-password" />
                    <b-form-invalid-feedback :state="form.errors.has('password')">
                      Password blank or incorrect
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="form.errors.has('non_field_errors')">
                      {{form.errors.get('non_field_errors')}}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4 text-white">
                        <b-spinner small type="grow" v-if="isLoading"></b-spinner>
                        <strong>Login</strong>
                      </b-button>
                    </b-col>
<!--                     <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card class="text-center py-5" style="width:44%">
              <b-card-body class="">
                <div>
                  <img src="img/brand/meds.jpg" width="257" height="" alt="Meds2go Logo">
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
export default {
  name: 'Login',
  data() {
    return {
        form: new Form({
          username: null,
          password: null
        }),
        isLoading: false
    }
  },
  computed: {
    ...mapState("auth", {
      user_groups: (state) => state.user_groups,
    }),
    clientUserGroup(){
      for (let x in this.user_groups){
        if (this.user_groups[x].name == "client"){
          return this.user_groups[x].id
        }
      }
    }
  },
  methods: {
    ...mapActions("auth", ["login","getUserGroups"]),
    ...mapActions("common", ["setFromLogin"]),
    onUpdate() {
      this.form.errors.clear()
    },
    onLogin(evt) {
      evt.preventDefault()

      this.isLoading = true
      this.login(this.form.data()).then(user => {
        this.setFromLogin(true)
        // if(user.groups.includes(this.clientUserGroup)){
        //   this.$router.replace('/clientdashboard')
        //   // this.$router.replace(this.$route.query.redirect || '/client/dashboard')
        // }else{
        //   this.$router.replace('/dashboard')
        //   // this.$router.replace(this.$route.query.redirect || '/dashboard')
        this.$router.push('/')
        // }
      })
      .catch(errors => {
        this.form.errors.record(errors)
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  created(){
    this.getUserGroups()
  },
  mounted(){
  }
}
</script>